export const GET_MENU = "get_menu";
export const GET_MENU_SUCCESSFUL = "get_menu_successful";
export const ADD_MENU = "add_menu";
export const PUT_MENU = "put_menu";
export const DELETE_MENU = "delete_menu";

export const API_ERROR = "api_failed";
